<app-contact-card-widget #contactCardWidget [contact]="model"></app-contact-card-widget>